import {ReactElement} from 'react';
import {Wrapper, Title, SecondaryText, List, ListItem, Dot} from './styled';

type Props = {
  title: string;
  subtitle: string;
  reasons?: string[];
  icon: ReactElement;
};
function UnavailableFeature({title, subtitle, reasons, icon}: Props) {
  if (!reasons) return null;
  return (
    <Wrapper>
      <Title>{title}</Title>
      {icon}
      <SecondaryText>{subtitle}</SecondaryText>
      <List className="no-access-feature__list">
        {reasons?.map((reason, index) => (
          <ListItem className="no-access-feature__reason-item" key={index}>
            <Dot />
            {reason}
          </ListItem>
        ))}
      </List>
    </Wrapper>
  );
}

export {UnavailableFeature};
